import React from 'react';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';
const areas = ['Camarillo', 'Thousand Oaks', 'Oxnard', 'Ventura', 'Agoura Hills', 'Calabasas', 'Woodland Hills', 'Westlake Village', 'Newbury Park', 'Oak Park', 'Simi Valley', 'Moorpark', 'Encino', 'Tarzana', 'Sherman Oaks', 'Chatsworth', 'Malibu'];
export function ServiceAreas() {
  return <section className="w-full bg-black py-16 px-4 border-t border-zinc-900" id="service-areas" data-id="element-276">
      <div className="max-w-4xl mx-auto" data-id="element-277">
        <div className="text-center mb-12" data-id="element-278">
          <h2 className="text-5xl md:text-6xl font-black uppercase mb-4" data-id="element-279">
            <span className="bg-clip-text text-transparent bg-gradient-to-b from-yellow-300 via-yellow-400 to-yellow-500" data-id="element-280">
              Mobile Car Detailing Service Areas
            </span>
          </h2>
          <div className="h-1 w-24 bg-red-600 mx-auto rounded-full shadow-[0_0_10px_rgba(220,38,38,0.8)]" data-id="element-281" />
          <p className="text-gray-400 text-lg max-w-2xl mx-auto mt-4" data-id="element-282">
            Professional mobile car detailing throughout Ventura County and San
            Fernando Valley — we bring the detail shop to your driveway
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3" data-id="element-283">
          {areas.map((area, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="bg-zinc-900/40 border border-zinc-800 rounded-lg px-4 py-3 text-center flex items-center justify-center gap-2 hover:border-red-900/50 transition-colors" data-id="element-284">
              <MapPin className="w-4 h-4 text-red-500 flex-shrink-0" data-id="element-285" />
              <span className="text-gray-300 font-medium text-sm md:text-base" data-id="element-286">
                {area}
              </span>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} className="text-sm text-center mt-8 text-[#FFFFFF]" data-id="element-287">
          Don't see your area? Call{' '}
          <a href="tel:8183819905" className="text-red-500 font-bold hover:underline" data-id="element-288">
            (818) 381-9905
          </a>{' '}
          — we may still be able to come to you!
        </motion.p>
      </div>
    </section>;
}